import styled from "styled-components";

const HeaderFlexBox = styled.div`
  display: flex;
  margin-left: 0.3rem;
  align-items: center;
`;
export default HeaderFlexBox;
